<div class="search-period" [class.search-period--open]="helper.FORM" [class.search-period--filled]="code">

  <!-- field -->
  <div
    class="inner"
    (hidden)="helper.FORM = null"
    [ngbPopover]="popContent"
    #popContentRef="ngbPopover"
    placement="bottom-left bottom-right"
    popoverClass="popover--search-period"
    [container]="'body'"
    [autoClose]="'outside'"
    (click)="openForm(popContentRef)"
    >
    <!-- empty -->
    @if (!code) {
      <span class="empty">{{placeholder}}</span>
    }
    <!-- filled -->
    @if (code) {
      <span class="label">{{placeholder}}:</span>
      <!-- code -->
      @if (!from && !until) {
        <span class="value">{{helper.selected?.title | translate }}</span>
      }
      <!-- range -->
      @if (from || until) {
        <span class="value">@if (from && !until) {
          <span class="label label--range m-l-0">{{'misc_from' | translate | lowercase}}</span>
          } @if (from) {
          {{from | formatTs: 'DD-MM-YYYY'}}
          } @if (until) {
          <span class="label label--range" [class.m-l-0]="!from">{{'misc_until' | translate | lowercase}}</span>
          } @if (until) {
          {{until | formatTs: 'DD-MM-YYYY'}}
        }</span>
      }
    }
    <!-- icon -->
    <i class="im-icon im-icon-triangle-rounded-down"></i>
  </div>

  <!-- popover -->
  <ng-template #popContent>
    @if (helper.FORM) {
      <div class="popover--inner">
        <div class="popover-rows-wrapper">
          @for (option of codeOptions; track option) {
            <div class="popover-row" (click)="helper.FORM.code = option.value">
              <div class="radio-wrap">
                <app-field-single-radio-sm [model]="option.value === helper.FORM.code"></app-field-single-radio-sm>
              </div>
              <div class="value-wrap">
                <div class="descr">{{ option.title | translate }}</div>
              </div>
            </div>
          }
          <div class="popover-row" (click)="helper.FORM.code = 'range'">
            <div class="radio-wrap">
              <app-field-single-radio-sm [model]="'range' === helper.FORM.code"></app-field-single-radio-sm>
            </div>
            <div class="value-wrap">
              <div class="descr">{{'searchperiod_option_range' | translate}}</div>
              <div class="range" style="min-height: 32px;">
                @if (!helper.reloadingDates) {
                  <app-field-date
                    [model]="helper.FORM.from"
                    (modelChange)="helper.FORM.from = $event; changeDate()"
                    [placeholder]="'misc_date_placeholder' | translate"
                    positionDateSelector="bottom"
                    [disableSince]="helper.FORM.until"
                    [disableOrEquals]="true"
                    [width]="'126px'">
                  </app-field-date>
                  <span class="and">{{'searchperiod_and' | translate}}</span>
                  <app-field-date
                    [model]="helper.FORM.until"
                    (modelChange)="helper.FORM.until = $event; changeDate()"
                    [placeholder]="'misc_date_placeholder' | translate"
                    positionDateSelector="bottom"
                    [disableUntil]="helper.FORM.from"
                    [disableOrEquals]="true"
                    [width]="'126px'">
                  </app-field-date>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="clear-wrap">
          <app-button
            class="confirm"
            [disabled]="!helper.FORM.code"
            [text]="'misc_apply' | translate"
            (emitClick)="closeForm()"
          ></app-button>
          @if (allowClear && code && helper?.FORM?.code) {
            <span class="clear" (click)="clear()">
              {{ 'misc_clear_selection' | translate }}
            </span>
          }
        </div>
      </div>
    }
  </ng-template>
</div>